module.exports = __webpack_public_path__ + "static/media/ico-whatsapp.600c2b60.svg";